export const routePaths = {
  dashboard: '/',
  newAccount: '/new-account',
  paywall: '/paywall',
  subscriptionLimit: '/subscription-limit',
  costRadarTrial: '/cost-radar-trial',
  storyousIntegration: '/storyous-integration',
  einvoicingIntegration: '/e-invoicing-sk',
  venueManagement: '/venue-management',
  customCheckout: '/custom-checkout',
  invoiceBilling: '/invoice-billing',
  supplierIntegrations: '/supplier-integrations',
  gracePeriod: '/failed-payment-settings',
} as const;

export enum Method {
  CREATE = '/create',
  UPDATE = '/update',
}

export type RoutePathsType = typeof routePaths;
export type RoutePathsKeys = keyof RoutePathsType;
export type RoutePathsValues = RoutePathsType[RoutePathsKeys];
